export default __webpack_public_path__ + "static/media/Theatro.c9b6bccf.png";